import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * useSchoolBoundaries — fetch board + per-school polygons for a lat/lng.
 * Returns null while loading, {} on error, or the FeatureCollection payload.
 */
export function useSchoolBoundaries(lat, lng) {
    const [data, setData] = useState(null);
    useEffect(() => {
        if (lat == null || lng == null) return;
        let cancelled = false;
        (async () => {
            try {
                const r = await api.get('/school-boundaries', { params: { lat, lng } });
                if (!cancelled) setData(r.data);
            } catch {
                if (!cancelled) setData({ features: [], boards: [], schools: [], has_per_school: false });
            }
        })();
        return () => { cancelled = true; };
    }, [lat, lng]);
    return data;
}
